// Angular
import { NgModule } from '@angular/core';
import { DateRangePickerComponent } from './date-range-picker/date-range-picker.component';
import { NgbModule, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { CoreModule } from '@core/core.module';
import { CommonModule } from '@angular/common';
import { TimepickerComponent } from './timepicker/timepicker.component';
import { FormsModule } from '@angular/forms';

@NgModule({
	imports: [CoreModule,FormsModule, NgbModule, NgbModalModule, CommonModule],
	declarations: [DateRangePickerComponent, TimepickerComponent],
	exports: [DateRangePickerComponent, TimepickerComponent],
})
export class DatepickerModule {}
